import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';

import {AlertItem} from '../../../models/staff/alertitem';
import {AlertItemService} from '../../../service/staff/service-alertitem';
import {Sessioncommand} from '../../../global/sessioncommand';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Component({
  selector: 'egov-alert-thongtin',
  templateUrl: './alert.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AlertThongTinComponent implements OnInit, AfterViewInit {
  public language = language;
  public alertItemList: AlertItem[] = [];

  constructor( public alertItemService: AlertItemService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
  ) {
  }
  ngAfterViewInit() {
  }

  ngOnInit(): void {
    this.alertItemService.getAll(Sessioncommand.staffId, Sessioncommand.maDonVi).subscribe(data => this.alertItemList = data);
  }
  public  show()
  {

  }
  createLink(type: number): string
  {
    if (type === 1 || type === 2 || type === 9)
      return '/giaiquyetsuvu/qlsuvu';
    if (type === 3)
      return '/vanbanden/qlvanbanden';
    if (type === 4)
      return '/vanbandi/qlvanbandi';
    if (type === 5)
      return '/chucnangchung/lichcongtac';
    if (type === 6)
      return '/chucnangchung/lichdonvi';
    if (type === 7)
      return '/chucnangchung/lichcanhan';

    return "";
  }

  createParam(type: number): any
  {
    if (type === 1)
      return { 'ty': 'ttn'};
    if (type === 2)
      return { 'ty': 'ycn'};
    if (type === 3)
      return { 'ty': 'cxl'};
    if (type === 4)
      return { 'ty': 'xl'};
    if (type === 9)
      return { 'ty': 'mt'};
    return null;
  }

  public hideConfirmationModal(): void {
    this._bsModalRef.hide();
  }
}

